// LearSpace Draw - DevOps Icons Library with Real Icons
// Using official CDN URLs for high-quality icons

export const ICON_CATEGORIES = [
  { id: 'kubernetes', name: 'Kubernetes', color: '#326CE5' },
  { id: 'aws', name: 'AWS Services', color: '#FF9900' },
  { id: 'cicd', name: 'CI/CD', color: '#4A90D9' },
  { id: 'containers', name: 'Conteneurisation', color: '#2496ED' },
  { id: 'orchestration', name: 'Orchestration', color: '#326CE5' },
  { id: 'iac', name: 'Infrastructure as Code', color: '#7B42BC' },
  { id: 'observability', name: 'Observabilité', color: '#E6522C' },
  { id: 'cloud', name: 'Cloud Providers', color: '#FF9900' },
  { id: 'security', name: 'Sécurité', color: '#D32F2F' },
  { id: 'databases', name: 'Bases de données', color: '#336791' },
  { id: 'networking', name: 'Réseau', color: '#00BCD4' },
  { id: 'messaging', name: 'Messaging', color: '#FF6B35' },
];

// Using CNCF landscape icons, devicons, and simple-icons CDN
const DEVICONS_CDN = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons';
const SIMPLEICONS_CDN = 'https://cdn.simpleicons.org';
const K8S_ICONS = 'https://raw.githubusercontent.com/kubernetes/community/master/icons/svg';
// Use Iconify API for reliable AWS icon delivery
const AWS_ICONS = 'https://api.iconify.design/simple-icons';

export const DEVOPS_ICONS = [
  // ============ KUBERNETES RESOURCES ============
  { 
    id: 'k8s-pod', 
    name: 'Pod', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'pod', 'container', 'workload'],
    iconUrl: `${K8S_ICONS}/resources/labeled/pod.svg`
  },
  { 
    id: 'k8s-deploy', 
    name: 'Deployment', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'deployment', 'workload', 'replica'],
    iconUrl: `${K8S_ICONS}/resources/labeled/deploy.svg`
  },
  { 
    id: 'k8s-svc', 
    name: 'Service', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'service', 'networking', 'loadbalancer'],
    iconUrl: `${K8S_ICONS}/resources/labeled/svc.svg`
  },
  { 
    id: 'k8s-ing', 
    name: 'Ingress', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'ingress', 'routing', 'http'],
    iconUrl: `${K8S_ICONS}/resources/labeled/ing.svg`
  },
  { 
    id: 'k8s-cm', 
    name: 'ConfigMap', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'configmap', 'configuration', 'config'],
    iconUrl: `${K8S_ICONS}/resources/labeled/cm.svg`
  },
  { 
    id: 'k8s-secret', 
    name: 'Secret', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'secret', 'credentials', 'security'],
    iconUrl: `${K8S_ICONS}/resources/labeled/secret.svg`
  },
  { 
    id: 'k8s-pv', 
    name: 'PersistentVolume', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'pv', 'storage', 'volume'],
    iconUrl: `${K8S_ICONS}/resources/labeled/pv.svg`
  },
  { 
    id: 'k8s-pvc', 
    name: 'PersistentVolumeClaim', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'pvc', 'storage', 'claim'],
    iconUrl: `${K8S_ICONS}/resources/labeled/pvc.svg`
  },
  { 
    id: 'k8s-ns', 
    name: 'Namespace', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'namespace', 'isolation', 'organization'],
    iconUrl: `${K8S_ICONS}/resources/labeled/ns.svg`
  },
  { 
    id: 'k8s-node', 
    name: 'Node', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'node', 'worker', 'machine'],
    iconUrl: `${K8S_ICONS}/resources/labeled/node.svg`
  },
  { 
    id: 'k8s-rs', 
    name: 'ReplicaSet', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'replicaset', 'scaling', 'replica'],
    iconUrl: `${K8S_ICONS}/resources/labeled/rs.svg`
  },
  { 
    id: 'k8s-ds', 
    name: 'DaemonSet', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'daemonset', 'daemon', 'node'],
    iconUrl: `${K8S_ICONS}/resources/labeled/ds.svg`
  },
  { 
    id: 'k8s-sts', 
    name: 'StatefulSet', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'statefulset', 'stateful', 'database'],
    iconUrl: `${K8S_ICONS}/resources/labeled/sts.svg`
  },
  { 
    id: 'k8s-job', 
    name: 'Job', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'job', 'batch', 'task'],
    iconUrl: `${K8S_ICONS}/resources/labeled/job.svg`
  },
  { 
    id: 'k8s-cronjob', 
    name: 'CronJob', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'cronjob', 'scheduled', 'cron'],
    iconUrl: `${K8S_ICONS}/resources/labeled/cronjob.svg`
  },
  { 
    id: 'k8s-hpa', 
    name: 'HPA', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'hpa', 'autoscaler', 'scaling'],
    iconUrl: `${K8S_ICONS}/resources/labeled/hpa.svg`
  },
  { 
    id: 'k8s-sa', 
    name: 'ServiceAccount', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'serviceaccount', 'rbac', 'identity'],
    iconUrl: `${K8S_ICONS}/resources/labeled/sa.svg`
  },
  { 
    id: 'k8s-role', 
    name: 'Role', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'role', 'rbac', 'permissions'],
    iconUrl: `${K8S_ICONS}/resources/labeled/role.svg`
  },
  { 
    id: 'k8s-netpol', 
    name: 'NetworkPolicy', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'networkpolicy', 'security', 'firewall'],
    iconUrl: `${K8S_ICONS}/resources/labeled/netpol.svg`
  },
  { 
    id: 'k8s-ep', 
    name: 'Endpoints', 
    category: 'kubernetes', 
    keywords: ['kubernetes', 'endpoints', 'service', 'networking'],
    iconUrl: `${K8S_ICONS}/resources/labeled/ep.svg`
  },

  // ============ AWS SERVICES ============
  // Using Iconify API for reliable SVG delivery
  { 
    id: 'aws-ec2', 
    name: 'EC2', 
    category: 'aws', 
    keywords: ['aws', 'ec2', 'compute', 'instance', 'vm'],
    iconUrl: `${AWS_ICONS}/amazonec2.svg?color=%23FF9900`
  },
  { 
    id: 'aws-s3', 
    name: 'S3', 
    category: 'aws', 
    keywords: ['aws', 's3', 'storage', 'bucket', 'object'],
    iconUrl: `${AWS_ICONS}/amazons3.svg?color=%23569A31`
  },
  { 
    id: 'aws-rds', 
    name: 'RDS', 
    category: 'aws', 
    keywords: ['aws', 'rds', 'database', 'mysql', 'postgres'],
    iconUrl: `${AWS_ICONS}/amazonrds.svg?color=%23527FFF`
  },
  { 
    id: 'aws-lambda', 
    name: 'Lambda', 
    category: 'aws', 
    keywords: ['aws', 'lambda', 'serverless', 'function'],
    iconUrl: `${AWS_ICONS}/awslambda.svg?color=%23FF9900`
  },
  { 
    id: 'aws-dynamodb', 
    name: 'DynamoDB', 
    category: 'aws', 
    keywords: ['aws', 'dynamodb', 'nosql', 'database'],
    iconUrl: `${AWS_ICONS}/amazondynamodb.svg?color=%234053D6`
  },
  { 
    id: 'aws-ecs', 
    name: 'ECS', 
    category: 'aws', 
    keywords: ['aws', 'ecs', 'container', 'fargate'],
    iconUrl: `${AWS_ICONS}/amazonecs.svg?color=%23FF9900`
  },
  { 
    id: 'aws-eks', 
    name: 'EKS', 
    category: 'aws', 
    keywords: ['aws', 'eks', 'kubernetes', 'cluster'],
    iconUrl: `${AWS_ICONS}/amazoneks.svg?color=%23FF9900`
  },
  { 
    id: 'aws-elb', 
    name: 'ELB/ALB', 
    category: 'aws', 
    keywords: ['aws', 'elb', 'alb', 'loadbalancer', 'nlb'],
    iconUrl: `${AWS_ICONS}/awselasticloadbalancing.svg?color=%238C4FFF`
  },
  { 
    id: 'aws-cloudfront', 
    name: 'CloudFront', 
    category: 'aws', 
    keywords: ['aws', 'cloudfront', 'cdn', 'edge'],
    iconUrl: `${AWS_ICONS}/amazoncloudfront.svg?color=%238C4FFF`
  },
  { 
    id: 'aws-route53', 
    name: 'Route 53', 
    category: 'aws', 
    keywords: ['aws', 'route53', 'dns', 'domain'],
    iconUrl: `${AWS_ICONS}/amazonroute53.svg?color=%238C4FFF`
  },
  { 
    id: 'aws-vpc', 
    name: 'VPC', 
    category: 'aws', 
    keywords: ['aws', 'vpc', 'network', 'subnet'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%23FF9900`
  },
  { 
    id: 'aws-iam', 
    name: 'IAM', 
    category: 'aws', 
    keywords: ['aws', 'iam', 'identity', 'security', 'role'],
    iconUrl: `${AWS_ICONS}/amazoniam.svg?color=%23DD344C`
  },
  { 
    id: 'aws-sqs', 
    name: 'SQS', 
    category: 'aws', 
    keywords: ['aws', 'sqs', 'queue', 'messaging'],
    iconUrl: `${AWS_ICONS}/amazonsqs.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-sns', 
    name: 'SNS', 
    category: 'aws', 
    keywords: ['aws', 'sns', 'notification', 'pubsub'],
    iconUrl: `${AWS_ICONS}/amazonsimplenotificationservice.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-cognito', 
    name: 'Cognito', 
    category: 'aws', 
    keywords: ['aws', 'cognito', 'auth', 'identity'],
    iconUrl: `${AWS_ICONS}/amazoncognito.svg?color=%23DD344C`
  },
  { 
    id: 'aws-apigw', 
    name: 'API Gateway', 
    category: 'aws', 
    keywords: ['aws', 'apigateway', 'api', 'rest'],
    iconUrl: `${AWS_ICONS}/amazonapigateway.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-secretsmanager', 
    name: 'Secrets Manager', 
    category: 'aws', 
    keywords: ['aws', 'secrets', 'credentials', 'vault'],
    iconUrl: `${AWS_ICONS}/awssecretsmanager.svg?color=%23DD344C`
  },
  { 
    id: 'aws-cloudwatch', 
    name: 'CloudWatch', 
    category: 'aws', 
    keywords: ['aws', 'cloudwatch', 'monitoring', 'logs'],
    iconUrl: `${AWS_ICONS}/amazoncloudwatch.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-elasticache', 
    name: 'ElastiCache', 
    category: 'aws', 
    keywords: ['aws', 'elasticache', 'redis', 'memcached', 'cache'],
    iconUrl: `${AWS_ICONS}/amazonelasticache.svg?color=%23C925D1`
  },
  { 
    id: 'aws-ecr', 
    name: 'ECR', 
    category: 'aws', 
    keywords: ['aws', 'ecr', 'registry', 'container', 'docker'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%23FF9900`
  },
  { 
    id: 'aws-kms', 
    name: 'KMS', 
    category: 'aws', 
    keywords: ['aws', 'kms', 'encryption', 'key'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%23DD344C`
  },
  { 
    id: 'aws-stepfunctions', 
    name: 'Step Functions', 
    category: 'aws', 
    keywords: ['aws', 'stepfunctions', 'workflow', 'orchestration'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-eventbridge', 
    name: 'EventBridge', 
    category: 'aws', 
    keywords: ['aws', 'eventbridge', 'events', 'bus'],
    iconUrl: `${AWS_ICONS}/amazoneventbridge.svg?color=%23FF4F8B`
  },
  { 
    id: 'aws-kinesis', 
    name: 'Kinesis', 
    category: 'aws', 
    keywords: ['aws', 'kinesis', 'streaming', 'realtime'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%238C4FFF`
  },
  { 
    id: 'aws-athena', 
    name: 'Athena', 
    category: 'aws', 
    keywords: ['aws', 'athena', 'query', 'sql', 'analytics'],
    iconUrl: `${AWS_ICONS}/amazonwebservices.svg?color=%238C4FFF`
  },

  // ============ CI/CD ============
  { 
    id: 'jenkins', 
    name: 'Jenkins', 
    category: 'cicd', 
    keywords: ['pipeline', 'build', 'ci', 'automation'],
    iconUrl: `${DEVICONS_CDN}/jenkins/jenkins-original.svg`
  },
  { 
    id: 'gitlab', 
    name: 'GitLab', 
    category: 'cicd', 
    keywords: ['git', 'repository', 'ci', 'devops'],
    iconUrl: `${DEVICONS_CDN}/gitlab/gitlab-original.svg`
  },
  { 
    id: 'github', 
    name: 'GitHub', 
    category: 'cicd', 
    keywords: ['git', 'repository', 'code', 'vcs'],
    iconUrl: `${DEVICONS_CDN}/github/github-original.svg`
  },
  { 
    id: 'github-actions', 
    name: 'GitHub Actions', 
    category: 'cicd', 
    keywords: ['workflow', 'automation', 'ci', 'pipeline'],
    iconUrl: `${SIMPLEICONS_CDN}/githubactions/2088FF`
  },
  { 
    id: 'bitbucket', 
    name: 'Bitbucket', 
    category: 'cicd', 
    keywords: ['git', 'repository', 'atlassian'],
    iconUrl: `${DEVICONS_CDN}/bitbucket/bitbucket-original.svg`
  },
  { 
    id: 'circleci', 
    name: 'CircleCI', 
    category: 'cicd', 
    keywords: ['ci', 'pipeline', 'build', 'automation'],
    iconUrl: `${DEVICONS_CDN}/circleci/circleci-plain.svg`
  },
  { 
    id: 'travis', 
    name: 'Travis CI', 
    category: 'cicd', 
    keywords: ['ci', 'build', 'automation'],
    iconUrl: `${DEVICONS_CDN}/travis/travis-plain.svg`
  },
  { 
    id: 'azure-devops', 
    name: 'Azure DevOps', 
    category: 'cicd', 
    keywords: ['microsoft', 'pipeline', 'boards'],
    iconUrl: `${SIMPLEICONS_CDN}/azuredevops/0078D7`
  },
  { 
    id: 'drone', 
    name: 'Drone CI', 
    category: 'cicd', 
    keywords: ['ci', 'pipeline', 'container'],
    iconUrl: `${SIMPLEICONS_CDN}/drone/212121`
  },
  { 
    id: 'tekton', 
    name: 'Tekton', 
    category: 'cicd', 
    keywords: ['kubernetes', 'pipeline', 'cloud-native'],
    iconUrl: `${SIMPLEICONS_CDN}/tekton/FD495C`
  },

  // ============ CONTAINERS ============
  { 
    id: 'docker', 
    name: 'Docker', 
    category: 'containers', 
    keywords: ['container', 'image', 'whale', 'dockerfile'],
    iconUrl: `${DEVICONS_CDN}/docker/docker-original.svg`
  },
  { 
    id: 'podman', 
    name: 'Podman', 
    category: 'containers', 
    keywords: ['container', 'rootless', 'daemonless'],
    iconUrl: `${DEVICONS_CDN}/podman/podman-original.svg`
  },
  { 
    id: 'containerd', 
    name: 'containerd', 
    category: 'containers', 
    keywords: ['runtime', 'cri', 'oci'],
    iconUrl: `${SIMPLEICONS_CDN}/containerd/575757`
  },
  { 
    id: 'harbor', 
    name: 'Harbor', 
    category: 'containers', 
    keywords: ['registry', 'security', 'vmware'],
    iconUrl: `${SIMPLEICONS_CDN}/harbor/60B932`
  },
  { 
    id: 'kaniko', 
    name: 'Kaniko', 
    category: 'containers', 
    keywords: ['build', 'kubernetes', 'daemonless'],
    iconUrl: `${SIMPLEICONS_CDN}/kaniko/FFA600`
  },

  // ============ ORCHESTRATION ============
  { 
    id: 'kubernetes', 
    name: 'Kubernetes', 
    category: 'orchestration', 
    keywords: ['k8s', 'cluster', 'pod', 'container'],
    iconUrl: `${DEVICONS_CDN}/kubernetes/kubernetes-plain.svg`
  },
  { 
    id: 'helm', 
    name: 'Helm', 
    category: 'orchestration', 
    keywords: ['chart', 'package', 'kubernetes', 'deploy'],
    iconUrl: `${DEVICONS_CDN}/helm/helm-original.svg`
  },
  { 
    id: 'argocd', 
    name: 'Argo CD', 
    category: 'orchestration', 
    keywords: ['gitops', 'deployment', 'kubernetes', 'sync'],
    iconUrl: `${DEVICONS_CDN}/argocd/argocd-original.svg`
  },
  { 
    id: 'rancher', 
    name: 'Rancher', 
    category: 'orchestration', 
    keywords: ['kubernetes', 'management', 'multi-cluster'],
    iconUrl: `${SIMPLEICONS_CDN}/rancher/0075A8`
  },
  { 
    id: 'openshift', 
    name: 'OpenShift', 
    category: 'orchestration', 
    keywords: ['redhat', 'kubernetes', 'platform'],
    iconUrl: `${SIMPLEICONS_CDN}/redhatopenshift/EE0000`
  },
  { 
    id: 'k3s', 
    name: 'K3s', 
    category: 'orchestration', 
    keywords: ['kubernetes', 'lightweight', 'rancher', 'edge'],
    iconUrl: `${SIMPLEICONS_CDN}/k3s/FFC61C`
  },
  { 
    id: 'nomad', 
    name: 'Nomad', 
    category: 'orchestration', 
    keywords: ['hashicorp', 'scheduler', 'workload'],
    iconUrl: `${SIMPLEICONS_CDN}/nomad/00CA8E`
  },
  { 
    id: 'fluxcd', 
    name: 'Flux CD', 
    category: 'orchestration', 
    keywords: ['gitops', 'kubernetes', 'reconciliation'],
    iconUrl: `${SIMPLEICONS_CDN}/flux/5468FF`
  },

  // ============ IaC ============
  { 
    id: 'terraform', 
    name: 'Terraform', 
    category: 'iac', 
    keywords: ['hashicorp', 'infrastructure', 'hcl', 'provisioning'],
    iconUrl: `${DEVICONS_CDN}/terraform/terraform-original.svg`
  },
  { 
    id: 'ansible', 
    name: 'Ansible', 
    category: 'iac', 
    keywords: ['redhat', 'automation', 'configuration', 'yaml'],
    iconUrl: `${DEVICONS_CDN}/ansible/ansible-original.svg`
  },
  { 
    id: 'pulumi', 
    name: 'Pulumi', 
    category: 'iac', 
    keywords: ['infrastructure', 'sdk', 'cloud'],
    iconUrl: `${DEVICONS_CDN}/pulumi/pulumi-original.svg`
  },
  { 
    id: 'vagrant', 
    name: 'Vagrant', 
    category: 'iac', 
    keywords: ['hashicorp', 'vm', 'development'],
    iconUrl: `${DEVICONS_CDN}/vagrant/vagrant-original.svg`
  },
  { 
    id: 'packer', 
    name: 'Packer', 
    category: 'iac', 
    keywords: ['hashicorp', 'image', 'build'],
    iconUrl: `${DEVICONS_CDN}/packer/packer-original.svg`
  },
  { 
    id: 'cloudformation', 
    name: 'CloudFormation', 
    category: 'iac', 
    keywords: ['aws', 'stack', 'template'],
    iconUrl: `${SIMPLEICONS_CDN}/amazonwebservices/FF9900`
  },
  { 
    id: 'crossplane', 
    name: 'Crossplane', 
    category: 'iac', 
    keywords: ['kubernetes', 'multi-cloud', 'control-plane'],
    iconUrl: `${SIMPLEICONS_CDN}/crossplane/FFCD3C`
  },

  // ============ OBSERVABILITY ============
  { 
    id: 'prometheus', 
    name: 'Prometheus', 
    category: 'observability', 
    keywords: ['metrics', 'monitoring', 'alerting', 'tsdb'],
    iconUrl: `${DEVICONS_CDN}/prometheus/prometheus-original.svg`
  },
  { 
    id: 'grafana', 
    name: 'Grafana', 
    category: 'observability', 
    keywords: ['dashboard', 'visualization', 'metrics'],
    iconUrl: `${DEVICONS_CDN}/grafana/grafana-original.svg`
  },
  { 
    id: 'datadog', 
    name: 'Datadog', 
    category: 'observability', 
    keywords: ['apm', 'logs', 'infrastructure'],
    iconUrl: `${SIMPLEICONS_CDN}/datadog/632CA6`
  },
  { 
    id: 'elasticsearch', 
    name: 'Elasticsearch', 
    category: 'observability', 
    keywords: ['search', 'logs', 'elk', 'analytics'],
    iconUrl: `${SIMPLEICONS_CDN}/elasticsearch/005571`
  },
  { 
    id: 'kibana', 
    name: 'Kibana', 
    category: 'observability', 
    keywords: ['visualization', 'elk', 'dashboard'],
    iconUrl: `${SIMPLEICONS_CDN}/kibana/005571`
  },
  { 
    id: 'jaeger', 
    name: 'Jaeger', 
    category: 'observability', 
    keywords: ['tracing', 'distributed', 'opentelemetry'],
    iconUrl: `${SIMPLEICONS_CDN}/jaeger/66CFE3`
  },
  { 
    id: 'newrelic', 
    name: 'New Relic', 
    category: 'observability', 
    keywords: ['apm', 'monitoring', 'observability'],
    iconUrl: `${SIMPLEICONS_CDN}/newrelic/1CE783`
  },
  { 
    id: 'splunk', 
    name: 'Splunk', 
    category: 'observability', 
    keywords: ['logs', 'siem', 'analytics'],
    iconUrl: `${SIMPLEICONS_CDN}/splunk/000000`
  },
  { 
    id: 'opentelemetry', 
    name: 'OpenTelemetry', 
    category: 'observability', 
    keywords: ['tracing', 'metrics', 'logs', 'cncf'],
    iconUrl: `${SIMPLEICONS_CDN}/opentelemetry/000000`
  },

  // ============ CLOUD PROVIDERS ============
  { 
    id: 'aws', 
    name: 'AWS', 
    category: 'cloud', 
    keywords: ['amazon', 'cloud', 'ec2', 's3'],
    iconUrl: `${DEVICONS_CDN}/amazonwebservices/amazonwebservices-plain-wordmark.svg`
  },
  { 
    id: 'gcp', 
    name: 'Google Cloud', 
    category: 'cloud', 
    keywords: ['google', 'gke', 'cloud'],
    iconUrl: `${DEVICONS_CDN}/googlecloud/googlecloud-original.svg`
  },
  { 
    id: 'azure', 
    name: 'Azure', 
    category: 'cloud', 
    keywords: ['microsoft', 'cloud', 'aks'],
    iconUrl: `${DEVICONS_CDN}/azure/azure-original.svg`
  },
  { 
    id: 'digitalocean', 
    name: 'DigitalOcean', 
    category: 'cloud', 
    keywords: ['droplet', 'cloud', 'kubernetes'],
    iconUrl: `${DEVICONS_CDN}/digitalocean/digitalocean-original.svg`
  },
  { 
    id: 'cloudflare', 
    name: 'Cloudflare', 
    category: 'cloud', 
    keywords: ['cdn', 'dns', 'security', 'workers'],
    iconUrl: `${DEVICONS_CDN}/cloudflare/cloudflare-original.svg`
  },
  { 
    id: 'vercel', 
    name: 'Vercel', 
    category: 'cloud', 
    keywords: ['serverless', 'next.js', 'edge'],
    iconUrl: `${SIMPLEICONS_CDN}/vercel/000000`
  },
  { 
    id: 'heroku', 
    name: 'Heroku', 
    category: 'cloud', 
    keywords: ['paas', 'deployment', 'dynos'],
    iconUrl: `${DEVICONS_CDN}/heroku/heroku-original.svg`
  },
  { 
    id: 'netlify', 
    name: 'Netlify', 
    category: 'cloud', 
    keywords: ['jamstack', 'serverless', 'cdn'],
    iconUrl: `${SIMPLEICONS_CDN}/netlify/00C7B7`
  },
  { 
    id: 'linode', 
    name: 'Linode', 
    category: 'cloud', 
    keywords: ['vps', 'cloud', 'akamai'],
    iconUrl: `${SIMPLEICONS_CDN}/linode/00A95C`
  },

  // ============ SECURITY ============
  { 
    id: 'vault', 
    name: 'Vault', 
    category: 'security', 
    keywords: ['hashicorp', 'secrets', 'encryption'],
    iconUrl: `${SIMPLEICONS_CDN}/vault/FFEC6E`
  },
  { 
    id: 'keycloak', 
    name: 'Keycloak', 
    category: 'security', 
    keywords: ['identity', 'sso', 'oauth', 'oidc'],
    iconUrl: `${SIMPLEICONS_CDN}/keycloak/4D4D4D`
  },
  { 
    id: 'trivy', 
    name: 'Trivy', 
    category: 'security', 
    keywords: ['scanner', 'vulnerability', 'aqua'],
    iconUrl: `${SIMPLEICONS_CDN}/trivy/1904DA`
  },
  { 
    id: 'falco', 
    name: 'Falco', 
    category: 'security', 
    keywords: ['runtime', 'detection', 'kubernetes'],
    iconUrl: `${SIMPLEICONS_CDN}/falco/00AEC7`
  },
  { 
    id: 'snyk', 
    name: 'Snyk', 
    category: 'security', 
    keywords: ['vulnerability', 'devsecops', 'scanning'],
    iconUrl: `${SIMPLEICONS_CDN}/snyk/4C4A73`
  },
  { 
    id: 'sonarqube', 
    name: 'SonarQube', 
    category: 'security', 
    keywords: ['code', 'quality', 'analysis'],
    iconUrl: `${SIMPLEICONS_CDN}/sonarqube/4E9BCD`
  },

  // ============ DATABASES ============
  { 
    id: 'postgresql', 
    name: 'PostgreSQL', 
    category: 'databases', 
    keywords: ['sql', 'relational', 'database'],
    iconUrl: `${DEVICONS_CDN}/postgresql/postgresql-original.svg`
  },
  { 
    id: 'mysql', 
    name: 'MySQL', 
    category: 'databases', 
    keywords: ['sql', 'relational', 'database'],
    iconUrl: `${DEVICONS_CDN}/mysql/mysql-original.svg`
  },
  { 
    id: 'mongodb', 
    name: 'MongoDB', 
    category: 'databases', 
    keywords: ['nosql', 'document', 'database'],
    iconUrl: `${DEVICONS_CDN}/mongodb/mongodb-original.svg`
  },
  { 
    id: 'redis', 
    name: 'Redis', 
    category: 'databases', 
    keywords: ['cache', 'key-value', 'memory'],
    iconUrl: `${DEVICONS_CDN}/redis/redis-original.svg`
  },
  { 
    id: 'cassandra', 
    name: 'Cassandra', 
    category: 'databases', 
    keywords: ['nosql', 'distributed', 'apache'],
    iconUrl: `${SIMPLEICONS_CDN}/apachecassandra/1287B1`
  },
  { 
    id: 'mariadb', 
    name: 'MariaDB', 
    category: 'databases', 
    keywords: ['sql', 'mysql', 'fork'],
    iconUrl: `${SIMPLEICONS_CDN}/mariadb/003545`
  },
  { 
    id: 'cockroachdb', 
    name: 'CockroachDB', 
    category: 'databases', 
    keywords: ['sql', 'distributed', 'cloud-native'],
    iconUrl: `${SIMPLEICONS_CDN}/cockroachlabs/6933FF`
  },
  { 
    id: 'neo4j', 
    name: 'Neo4j', 
    category: 'databases', 
    keywords: ['graph', 'database', 'cypher'],
    iconUrl: `${DEVICONS_CDN}/neo4j/neo4j-original.svg`
  },

  // ============ NETWORKING ============
  { 
    id: 'nginx', 
    name: 'NGINX', 
    category: 'networking', 
    keywords: ['proxy', 'web-server', 'load-balancer'],
    iconUrl: `${DEVICONS_CDN}/nginx/nginx-original.svg`
  },
  { 
    id: 'traefik', 
    name: 'Traefik', 
    category: 'networking', 
    keywords: ['proxy', 'ingress', 'kubernetes'],
    iconUrl: `${DEVICONS_CDN}/traefikproxy/traefikproxy-original.svg`
  },
  { 
    id: 'haproxy', 
    name: 'HAProxy', 
    category: 'networking', 
    keywords: ['load-balancer', 'proxy', 'tcp'],
    iconUrl: `${SIMPLEICONS_CDN}/haproxy/009639`
  },
  { 
    id: 'envoy', 
    name: 'Envoy', 
    category: 'networking', 
    keywords: ['proxy', 'service-mesh', 'sidecar'],
    iconUrl: `${SIMPLEICONS_CDN}/envoyproxy/AC6199`
  },
  { 
    id: 'istio', 
    name: 'Istio', 
    category: 'networking', 
    keywords: ['service-mesh', 'kubernetes', 'traffic'],
    iconUrl: `${SIMPLEICONS_CDN}/istio/466BB0`
  },
  { 
    id: 'consul', 
    name: 'Consul', 
    category: 'networking', 
    keywords: ['hashicorp', 'service-discovery', 'mesh'],
    iconUrl: `${SIMPLEICONS_CDN}/consul/F24C53`
  },
  { 
    id: 'linkerd', 
    name: 'Linkerd', 
    category: 'networking', 
    keywords: ['service-mesh', 'kubernetes', 'cncf'],
    iconUrl: `${SIMPLEICONS_CDN}/linkerd/2BEDA7`
  },

  // ============ MESSAGING ============
  { 
    id: 'kafka', 
    name: 'Kafka', 
    category: 'messaging', 
    keywords: ['streaming', 'events', 'apache', 'queue'],
    iconUrl: `${DEVICONS_CDN}/apachekafka/apachekafka-original.svg`
  },
  { 
    id: 'rabbitmq', 
    name: 'RabbitMQ', 
    category: 'messaging', 
    keywords: ['queue', 'amqp', 'broker'],
    iconUrl: `${DEVICONS_CDN}/rabbitmq/rabbitmq-original.svg`
  },
  { 
    id: 'nats', 
    name: 'NATS', 
    category: 'messaging', 
    keywords: ['messaging', 'cloud-native', 'streaming'],
    iconUrl: `${SIMPLEICONS_CDN}/nats.io/27AAE1`
  },
  { 
    id: 'pulsar', 
    name: 'Apache Pulsar', 
    category: 'messaging', 
    keywords: ['streaming', 'pub-sub', 'apache'],
    iconUrl: `${SIMPLEICONS_CDN}/apachepulsar/188FFF`
  },
  { 
    id: 'activemq', 
    name: 'ActiveMQ', 
    category: 'messaging', 
    keywords: ['jms', 'broker', 'apache'],
    iconUrl: `${SIMPLEICONS_CDN}/apacheactivemq/D22128`
  },
];

// Search icons by name or keyword
export const searchIcons = (query) => {
  const lowerQuery = query.toLowerCase();
  return DEVOPS_ICONS.filter(icon => 
    icon.name.toLowerCase().includes(lowerQuery) ||
    icon.keywords.some(k => k.includes(lowerQuery))
  );
};

// Get icons by category
export const getIconsByCategory = (categoryId) => {
  return DEVOPS_ICONS.filter(icon => icon.category === categoryId);
};
